import { render, staticRenderFns } from "./ConfirmDeviceDisconnectInvModal.vue?vue&type=template&id=2c774f7d&scoped=true&"
import script from "./ConfirmDeviceDisconnectInvModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeviceDisconnectInvModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c774f7d",
  null
  
)

export default component.exports